import React, { useState, useRef, useEffect } from 'react'
import * as d3 from 'd3'
import { select } from 'd3';
import './AllLineChart.css'

function AllLineChart({chart, setChart}) {
    // const [data] = useState([10,20,30,40,30,50,10,20,30,40,30,50]);
    const [data] =  useState([4446.59,
    4397.45,
    4545.86,
    4530.41,
    4602.45,
    4631.6,
    4575.52,
    4543.06,
    4520.16,
    4456.24,
    4412.53,
    4488.28,
    4500.21,
    4481.15,
    4525.12,
    4582.64,
    4545.86,
    4530.41,
    4602.45,
    4631.6,
    4575.52,
    4543.06,
    4520.16,
    4456.24,
    4511.61,
    4461.18,
    4463.12,
    4411.67,
    4412.53,
    4488.28,
    4500.21,
    4481.15,
    4525.12,
    4582.64,
    4545.86,
    4357.86,
    4262.45,
    4173.11])

   
    const svgRef = useRef();

    useEffect(() => {
        const w = document.body.clientWidth
        const h = 244;
        const svg = d3.select(svgRef.current)
          .attr('width', w)
          .attr('height', h)
          .style('background', '#FFFFFF')
          .style('margin-top', '0');

        const xScale = d3.scaleLinear()
          .domain([0, data.length - 1])
          .range([0, w]);
        const yScale = d3.scaleLinear()
          .domain([4000, 5000])
          .range([h, 0 ]);
        const generateScaledLine = d3.line()
          .x((d, i) => xScale(i))
          .y(yScale);
         


        svg.selectAll('.line')
          .data([data])
          .join('path')
            .attr('d', d => generateScaledLine(d))
            .attr('fill', 'none')
            .attr("stroke-width", '1.5')
            .attr('stroke', '#8dc63f');
      
    }, [data]);
  return (
    <div className='year-chart-container'>
    <svg ref={svgRef}   ></svg>

 
    </div>
  )
}

export default AllLineChart

